import LayoutField from 'component/element/workdoc/layout/form-layout'
import CheckEmployeeFilter from './CheckEmployeeFilter'
import HeaderEmployeeFilter from './HeaderEmployeeFilter' 

export const DEFAULT_SCHEMA = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        header_group0: {type: 'string', title: 'ข้อมูลส่วนตัว', default: false},
        employee_id: {type: 'boolean', title: 'รหัสพนักงาน', default: false},
        first_name: {type: 'boolean', title: 'ชื่อ', default: false},
        last_name: {type: 'boolean', title: 'นามสกุล', default: false},
        nick_name: {type: 'boolean', title: 'ชื่อเล่น', default: false},
        mobile: {type: 'boolean', title: 'มือถือ', default: false},
        address_registration: {type: 'boolean', title: 'ทะเบียนบ้าน', default: false},
        current_address: {type: 'boolean', title: 'ที่อยู่ปัจจุบัน', default: false},
        gender: {type: 'boolean', title: 'เพศ', default: false},
        religion: {type: 'boolean', title: 'ศาสนา', default: false},
        race: {type: 'boolean', title: 'เชื้อชาติ', default: false},
        nationality: {type: 'boolean', title: 'สัญชาติ', default: false},
        height: {type: 'boolean', title: 'ส่วนสูง', default: false},
        weight: {type: 'boolean', title: 'นำ้หนัก', default: false},
        marriage_status: {type: 'boolean', title: 'สถานะ', default: false},
        children: {type: 'boolean', title: 'จำนวนบุตร', default: false},
        header_group1: {type: 'string', title: 'ข้อมูลบัตรประจำตัว', default: false},
        dob_date: {type: 'boolean', title: 'วันเดือนปีเกิด', default: false},
        id_card: {type: 'boolean', title: 'บัตรประชาชน', default: false},
        ssn: {type: 'boolean', title: 'เลขที่ประกันสังคม', default: false},
        no_taxpayer: {type: 'boolean', title: 'เลขที่ผู้เสียภาษี', default: false},
        bank_name: {type: 'boolean', title: 'ธนาคาร', default: false},
        bank_account: {type: 'boolean', title: 'เลขที่บัญชี', default: false},
        header_group2: {type: 'string', title: 'ข้อมูลการทำงาน', default: false},
        start_work_date: {type: 'boolean', title: 'เริ่มทำงาน', default: false},
        permanance_work_date: {type: 'boolean', title: 'บรรจุเป็นพนักงาน', default: false},
        position: {type: 'boolean', title: 'ตำแหน่ง', default: false},
        department: {type: 'boolean', title: 'แผนก', default: false},
        work_status: {type: 'boolean', title: 'สถานะการทำงาน', default: false},
        slip_per_month: {type: 'boolean', title: 'ออกสลิป', default: false},
        exit_date: {type: 'boolean', title: 'ลาออกวันที่', default: false},
        exit_reason: {type: 'boolean', title: 'เหตุที่ออก', default: false},
        exit_remark: {type: 'boolean', title: 'หมายเหตุ', default: false},
        header_group3: {type: 'string', title: 'ข้อมูลการเงิน', default: false},
        net_saving: {type: 'boolean', title: 'เงินสะสม(ปัจจุบัน)', default: false},
        slip_by: {type: 'boolean', title: 'ผู้ออกสลิปเงินเดือน', default: false}
    }    
}

export const DEFAULT_UI_SCHEMA = {
    'ui:field': LayoutField,
    'ui:layout': [
        [
            {name: 'header_group0', props: {md: 12}}
        ],
        [
            {name: 'employee_id', props: {md: 4}},
            {name: 'first_name', props: {md: 4}},
            {name: 'last_name', props: {md: 4}}
        ],
        [
            {name: 'nick_name', props: {md: 4}},
            {name: 'mobile', props: {md: 4}},
            {name: 'address_registration', props: {md: 4}}
        ],
        [
            {name: 'current_address', props: {md: 4}},
            {name: 'gender', props: {md: 4}},
            {name: 'religion', props: {md: 4}}
        ],
        [
            {name: 'race', props: {md: 4}},
            {name: 'nationality', props: {md: 4}},
            {name: 'height', props: {md: 4}}
        ],
        [
            {name: 'weight', props: {md: 4}},
            {name: 'marriage_status', props: {md: 4}},
            {name: 'children', props: {md: 4}}
        ],
        [
            {name: 'header_group1', props: {md: 12}}
        ],
        [
            {name: 'dob_date', props: {md: 4}},
            {name: 'id_card', props: {md: 4}},
            {name: 'ssn', props: {md: 4}},
        ],
        [
            {name: 'no_taxpayer', props: {md: 4}},
            {name: 'bank_name', props: {md: 4}},
            {name: 'bank_account', props: {md: 4}}
        ],
        [
            {name: 'header_group2', props: {md: 12}}
        ],
        [
            {name: 'start_work_date', props: {md: 4}},
            {name: 'permanance_work_date', props: {md: 4}},
            {name: 'position', props: {md: 4}}
        ],
        [
            {name: 'department', props: {md: 4}},
            {name: 'work_status', props: {md: 4}},
            {name: 'slip_per_month', props: {md: 4}}
        ],
        [
            {name: 'exit_date', props: {md: 4}},
            {name: 'exit_reason', props: {md: 4}},
            {name: 'exit_remark', props: {md: 4}}
        ],
        [
            {name: 'header_group3', props: {md: 12}}
        ],
        [
            {name: 'net_saving', props: {md: 4}},
            {name: 'slip_by', props: {md: 4}}
        ]     
    ],
    header_group0: {'ui:field': HeaderEmployeeFilter},
    employee_id: {'ui:field': CheckEmployeeFilter},
    first_name: {'ui:field': CheckEmployeeFilter},
    last_name: {'ui:field': CheckEmployeeFilter},
    nick_name: {'ui:field': CheckEmployeeFilter},
    mobile: {'ui:field': CheckEmployeeFilter},
    address_registration: {'ui:field': CheckEmployeeFilter},
    current_address: {'ui:field': CheckEmployeeFilter},
    gender: {'ui:field': CheckEmployeeFilter},
    religion: {'ui:field': CheckEmployeeFilter},
    race: {'ui:field': CheckEmployeeFilter},
    nationality: {'ui:field': CheckEmployeeFilter},
    height: {'ui:field': CheckEmployeeFilter},
    weight: {'ui:field': CheckEmployeeFilter},
    marriage_status: {'ui:field': CheckEmployeeFilter},
    children: {'ui:field': CheckEmployeeFilter},
    header_group1: {'ui:field': HeaderEmployeeFilter},
    dob_date: {'ui:field': CheckEmployeeFilter},
    id_card: {'ui:field': CheckEmployeeFilter},
    ssn: {'ui:field': CheckEmployeeFilter},
    no_taxpayer: {'ui:field': CheckEmployeeFilter},
    bank_name: {'ui:field': CheckEmployeeFilter},
    bank_account: {'ui:field': CheckEmployeeFilter},
    header_group2: {'ui:field': HeaderEmployeeFilter},
    start_work_date: {'ui:field': CheckEmployeeFilter},
    permanance_work_date: {'ui:field': CheckEmployeeFilter},
    position: {'ui:field': CheckEmployeeFilter},
    department: {'ui:field': CheckEmployeeFilter},
    work_status: {'ui:field': CheckEmployeeFilter},
    slip_per_month: {'ui:field': CheckEmployeeFilter},
    exit_date: {'ui:field': CheckEmployeeFilter},
    exit_reason: {'ui:field': CheckEmployeeFilter},
    exit_remark: {'ui:field': CheckEmployeeFilter},
    header_group3: {'ui:field': HeaderEmployeeFilter},
    net_saving: {'ui:field': CheckEmployeeFilter},
    slip_by: {'ui:field': CheckEmployeeFilter}
}


// WEBPACK FOOTER //
// ./src/view/hr/EmployeeFilterSettingGenFormSchema.js